// Components/BackIcon.jsx
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "primereact/button";

const BackIcon = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const hideBackForPaths = ["/", "/login"];

  if (hideBackForPaths.includes(location.pathname)) {
    return null;
  }

  return (
    <div style={styles.wrapper}>
      <Button
        icon="pi pi-arrow-left"
        className="p-button-rounded p-button-secondary p-button-sm"
        style={styles.button}
        onClick={() => navigate(-1)}
        tooltip="Go Back"
        tooltipOptions={{ position: "right" }}
      />
    </div>
  );
};

const styles = {
  wrapper: {
    position: "fixed",
    bottom: "20px",
    left: "20px",
    zIndex: 1000,
  },
  button: {
    backgroundColor: "#ffffff",
    color: "#333",
    border: "1px solid #ccc",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
    transition: "all 0.2s ease-in-out",
  },
};

export default BackIcon;
